export default "/_next/static/chunks/fonts/Source Sans Pro Light-0d4a9a1bc6d71ce32780ab68b10170be.otf";